import { Navigate, Outlet } from 'react-router-dom'
import useUserPermissions from '../../hooks/useUserPermissions'

export const AdminGuard = () => {
    const { hasUserPermission } = useUserPermissions()
    const isAdmin = hasUserPermission('ADMIN')

    if (!isAdmin) {
        return <Navigate to="/" replace />
    }
    return <Outlet />
}
